export default {
  'Arizona Cardinals': {
    displayName: 'ARI Cardinals',
    logoUrl: 'nfl/arizona_cardinals.webp',
  },
  'Baltimore Ravens': {
    displayName: 'BAL Ravens',
    logoUrl: 'nfl/baltimore_ravens.webp',
  },
  'Atlanta Falcons': {
    displayName: 'ATL Falcons',
    logoUrl: 'nfl/atlanta_falcons.webp',
  },
  'Buffalo Bills': {
    displayName: 'BUF Bills',
    logoUrl: 'nfl/buffalo_bills.webp',
  },
  'Carolina Panthers': {
    displayName: 'CAR Panthers',
    logoUrl: 'nfl/carolina_panthers.webp',
  },
  'Cincinnati Bengals': {
    displayName: 'CIN Bengals',
    logoUrl: 'nfl/cincinnati_bengals.webp',
  },
  'Chicago Bears': {
    displayName: 'CHI Bears',
    logoUrl: 'nfl/chicago_bears.webp',
  },
  'Cleveland Browns': {
    displayName: 'CLE Browns',
    logoUrl: 'nfl/cleveland_browns.webp',
  },
  'Dallas Cowboys': {
    displayName: 'DAL Cowboys',
    logoUrl: 'nfl/dallas_cowboys.webp',
  },
  'Denver Broncos': {
    displayName: 'DEN Broncos',
    logoUrl: 'nfl/denver_broncos.webp',
  },
  'Detroit Lions': {
    displayName: 'DET Lions',
    logoUrl: 'nfl/detroit_lions.webp',
  },
  'Houston Texans': {
    displayName: 'HOU Texans',
    logoUrl: 'nfl/houston_texans.webp',
  },
  'Green Bay Packers': {
    displayName: 'GB Packers',
    logoUrl: 'nfl/green_bay_packers.webp',
  },
  'Indianapolis Colts': {
    displayName: 'IND Colts',
    logoUrl: 'nfl/indianapolis_colts.webp',
  },
  'Los Angeles Rams': {
    displayName: 'LAR Rams',
    logoUrl: 'nfl/los_angeles_rams.webp',
  },
  'Jacksonville Jaguars': {
    displayName: 'JAX Jaguars',
    logoUrl: 'nfl/jacksonville_jaguars.webp',
  },
  'Minnesota Vikings': {
    displayName: 'MIN Vikings',
    logoUrl: 'nfl/minnesota_vikings.webp',
  },
  'Kansas City Chiefs': {
    displayName: 'KC Chiefs',
    logoUrl: 'nfl/kansas_city_chiefs.webp',
  },
  'New Orleans Saints': {
    displayName: 'NO Saints',
    logoUrl: 'nfl/new_orleans_saints.webp',
  },
  'Las Vegas Raiders': {
    displayName: 'LVR Raiders',
    logoUrl: 'nfl/las_vegas_raiders.webp',
  },
  'New York Giants': {
    displayName: 'NYG Giants',
    logoUrl: 'nfl/new_york_giants.webp',
  },
  'Los Angeles Chargers': {
    displayName: 'LAC Chargers',
    logoUrl: 'nfl/los_angeles_chargers.webp',
  },
  'Philadelphia Eagles': {
    displayName: 'PHI Eagles',
    logoUrl: 'nfl/philadelphia_eagles.webp',
  },
  'Miami Dolphins': {
    displayName: 'MIA Dolphins',
    logoUrl: 'nfl/miami_dolphins.webp',
  },
  'San Francisco 49ers': {
    displayName: 'SF 49ers',
    logoUrl: 'nfl/san_francisco_49ers.webp',
  },
  'New England Patriots': {
    displayName: 'NE Patriots',
    logoUrl: 'nfl/new_england_patriots.webp',
  },
  'Seattle Seahawks': {
    displayName: 'SEA Seahawks',
    logoUrl: 'nfl/seattle_seahawks.webp',
  },
  'New York Jets': {
    displayName: 'NYJ Jets',
    logoUrl: 'nfl/new_york_jets.webp',
  },
  'Tampa Bay Buccaneers': {
    displayName: 'TB Buccaneers',
    logoUrl: 'nfl/tampa_bay_buccaneers.webp',
  },
  'Pittsburgh Steelers': {
    displayName: 'PIT Steelers',
    logoUrl: 'nfl/pittsburgh_steelers.webp',
  },
  'Washington Commanders': {
    displayName: 'WAS Commanders',
    logoUrl: 'nfl/washington_commanders.webp',
  },
  'Tennessee Titans': {
    displayName: 'TEN Titans',
    logoUrl: 'nfl/tennessee_titans.webp',
  },
};
